import usePageSEO from '@/hooks/usePageSEO';
import { useLanguage } from '@/contexts/LanguageContext';
import PageLayout from '@/components/feature/PageLayout';
import AboutHero from './components/AboutHero';
import AboutWhoWeAre from './components/AboutWhoWeAre';
import AboutRole from './components/AboutRole';
import AboutMilestone from './components/AboutMilestone';
import AboutFuture from './components/AboutFuture';
import AboutCTA from './components/AboutCTA';

export default function About() {
  const { lang } = useLanguage();

  usePageSEO({
    title: {
      zh: '關於我們｜聚量應用材料股份有限公司 — 廢棄塑膠再生技術先驅',
      en: 'About Us | PolyQ Applied Materials Co., Ltd. — Pioneer in Plastic Waste Recycling Technology',
      ja: '会社概要 | 聚量応用材料株式会社 — 廃プラスチック再生技術のパイオニア',
    },
    description: {
      zh: '聚量應用材料以 PQernel® 奈米擴鏈技術，協助廢棄塑膠升級為高價值再生材料，推動循環經濟、低碳材料與 ESG 永續發展。',
      en: 'PolyQ Applied Materials uses PQernel® nano chain extension technology to upgrade waste plastics into high-value recycled materials, driving circular economy, low-carbon materials, and ESG sustainability.',
      ja: '聚量応用材料はPQernel®ナノ鎖延長技術により廃プラスチックを高付加価値の再生材料へとアップグレードし、サーキュラーエコノミー・低炭素材料・ESGサステナビリティを推進します。',
    },
    keywords: {
      zh: '聚量應用材料, 關於我們, PQernel, 塑膠再生, 奈米擴鏈, 循環經濟, 低碳材料, ESG, 材料科技, 台灣塑膠產業, 台中材料廠',
      en: 'PolyQ Applied Materials, about us, PQernel, plastic recycling, nano chain extender, circular economy, low-carbon materials, ESG, material science, Taiwan plastics industry',
      ja: '聚量応用材料, 会社概要, PQernel, プラスチック再生, ナノ鎖延長, サーキュラーエコノミー, 低炭素材料, ESG, 材料技術, 台湾プラスチック産業',
    },
    path: '/about',
    jsonLd: {
      '@type': 'AboutPage',
      name: '關於聚量應用材料',
      url: (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL || 'https://www.juuliang.com') + '/about',
      about: {
        '@type': 'Organization',
        name: '聚量應用材料股份有限公司',
        alternateName: 'PolyQ Applied Materials Co., Ltd.',
        description: (lang === 'en'
          ? 'PolyQ Applied Materials uses PQernel® nano chain extension technology to upgrade waste plastics into high-value recycled materials.'
          : lang === 'ja'
            ? '聚量応用材料はPQernel®ナノ鎖延長技術により廃プラスチックを高付加価値の再生材料へとアップグレードします。'
            : '聚量應用材料以 PQernel® 奈米擴鏈技術，協助廢棄塑膠升級為高價值再生材料，推動循環經濟與 ESG 永續發展。'),
      },
    },
  });

  return (
    <PageLayout>
      <AboutHero />
      <AboutWhoWeAre />
      <AboutRole />
      <AboutMilestone />
      <AboutFuture />
      <AboutCTA />
    </PageLayout>
  );
}